module.exports = __webpack_public_path__ + "img/xingan-6ee574.png";